export default "__VITE_ASSET__DjpHR$PE__"